(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mistara-shelf"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mistara-shelf')) {
    class MistaraShelf extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.controller = new AbortController();
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          if (!this.isConnected) return;
          this.track = this.querySelector('[data-shelf-track]');
          this.filter ||= 'all';
          this.applyFilter(this.filter);
          this.loadLatestProducts(this.controller.signal);
          this.addEventListener('click', (event) => {
            if (!(event.target instanceof Element)) return;
            const button = event.target.closest('[data-shelf-filter], [data-shelf-prev], [data-shelf-next], [data-shelf-favorite]');
            if (!button || button.closest('mistara-shelf') !== this) return;
            if (button.hasAttribute('data-shelf-filter')) {
              this.applyFilter(button.dataset.shelfFilter);
              this.track?.scrollTo({ left: 0, behavior: 'instant' });
              return;
            }
            if (button.hasAttribute('data-shelf-prev') || button.hasAttribute('data-shelf-next')) {
              this.scrollSlider(button.hasAttribute('data-shelf-prev') ? -1 : 1);
              return;
            }
            const active = button.getAttribute('aria-pressed') !== 'true';
            button.setAttribute('aria-pressed', String(active));
            button.classList.toggle('is-active', active);
          }, { signal: this.controller.signal });
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
      }

      async loadLatestProducts(signal) {
        const url = this.dataset.latestProductsUrl;
        if (!url || !this.track) return;
        try {
          // Shopify sorts the entire catalog before rendering the limited cards.
          // This avoids limiting "latest" to the first 50 alphabetically sorted products.
          const response = await fetch(url, { signal });
          if (!response.ok) return;
          const html = await response.text();
          if (signal.aborted || !this.isConnected) return;
          const rendered = new DOMParser().parseFromString(html, 'text/html');
          const track = rendered.getElementById(this.id)?.querySelector('[data-shelf-track]');
          if (!track) return;
          this.track.replaceChildren(...track.childNodes);
          this.applyFilter(this.filter);
          this.track.scrollLeft = 0;
        } catch (error) {
          // Retain the server-rendered products when offline or during an editor reload.
          if (error.name !== 'AbortError') console.warn('Mistara latest products could not refresh.', error);
        }
      }
      applyFilter(filter) {
        this.filter = ['all', 'kadak', 'restart', 'duo'].includes(filter) ? filter : 'all';
        this.querySelectorAll('[data-shelf-filter]').forEach((button) => {
          const active = button.dataset.shelfFilter === this.filter;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        this.querySelectorAll('[data-shelf-card]').forEach((card) => {
          card.hidden = this.filter !== 'all' && card.dataset.shelfMode !== this.filter;
        });
      }

      scrollSlider(direction) {
        if (!this.track) return;
        const card = this.track.querySelector('[data-shelf-card]:not([hidden])');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({
          left: (card.getBoundingClientRect().width + gap) * direction,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }
    }
    customElements.define('mistara-shelf', MistaraShelf);
  }

  } catch(e) { console.error(e); }
})();
})();
